import(/* webpackMode: "eager" */ "/app/apps/seller/app/(public)/error.tsx");
